import * as $ from "jquery";
import {EpMap} from "../../map/map";
import {transform} from "ol/proj";
import {toastAlert} from "../../toastAlert";
import {EpLayer} from "../../map/layers/layer";
import {farInventoryLocationStyle, inventoryLocationStyle} from "../../map/styles/inventory-locations";
import {EpInventoryObservations} from "../../map/layers/inventory-observations";
import {closeModal, openModal} from "../../utilities";
import {confirmModal} from "../../confirmModal";
import {clearErrors, enableFormBack, handleValidationErrors, releaseUnsubmittedForm} from "../../forms";
import {buildItemFromForm, getSubtypeFromTree, getTypeFromTree, itemFormCommon} from "./item-form-common";
import {nanoid} from "nanoid";
import {EpInventoryLocationTransects} from "../../map/layers/inventory-location-transects";
import {EpInventoryLocationAreas} from "../../map/layers/inventory-location-areas";
import {EpInventoryLocationRoutes} from "../../map/layers/inventory-location-routes";
import {coordinatesToGeoJSON} from "../../map/utilities";
import * as turf from '@turf/turf';
import moment from "moment";
import Spinner from "../../spinner";
import axios from "axios";

export const addData = () => {

    itemFormCommon();

    let mapContainer = $("#mapContainer");
    let body = $('body')
    let modal = $('#addItemModal');

    let form = $('form#addInventoryData');
    let inventoryLocationInput = $('[name="inventory_location_id"]');
    let latitudeInput = $('[name="latitude"]');
    let longitudeInput = $('[name="longitude"]');
    let typeInput = $('[name="type"]');
    let subtypeInput = $('[name="subtype"]');
    let quantityInput = $('[name="quantity"]');
    let commentsInput = $('[name="comments"]');
    let itemsTable = $('#items');
    let addItemButton = $('#addItemButton');
    let dictionaryInputsContainer = $('.dictionary-inputs');

    const isWithPhotos = $(form).find('[name="attachments[]"]').length

    let forestries = [];
    if(typeof window._forestries != 'undefined') {
        forestries = JSON.parse(window._forestries);
    }

    let hasBeenEdited = false;

    const inventoryType = parseInt(window._inventory_type);

    let items = [];
    let editingId = null;

    let observations = [];
    if (typeof window._observations != 'undefined') {
        observations = JSON.parse(window._observations);
    }

    let locations = [];
    if (typeof window._locations != 'undefined') {
        locations = JSON.parse(window._locations);
    }

    /// Table events
    itemsTable.on('draw.dt', function() {
        itemsTable.$('[data-bs-toggle="tooltip"]').each(function() {
            new bootstrap.Tooltip(this)
        })
    })

    /// Form handling
    const submitForm = async (form) => {
        let spinner = new Spinner();
        try {
            const add = (item, name) => {
                form.append(`<input type="hidden" name="item[${item.id}][${name}]" value="${item[name]}" />`)
            }

            for (let item of items) {
                add(item, 'id')
                add(item, 'animal_type_id')
                add(item, 'animal_id')
                add(item, 'quantity')
                add(item, 'comments')
                add(item, 'exists')
                add(item, 'is_edited')

                if (inventoryType === 4) {
                    add(item, 'is_inspected')
                    // add(item, 'settlement_type')
                }

                for (let detail of item.details) {
                    // if(inventoryType === 4 && parseInt(item.settlement_type) === 1) {
                    //     continue;
                    // }

                    form.append(`<input type="hidden" name="item[${item.id}][details][${detail.dictionary_id}][dictionary_id]" value="${detail.dictionary_id}" />`)
                    form.append(`<input type="hidden" name="item[${item.id}][details][${detail.dictionary_id}][value]" value="${detail.value}" />`)
                }
            }

            let response = await axios.post($(form).attr('action'), $(form).serialize());
            if (response.data.code !== 200) {
                if (response.data.errors) {
                    handleValidationErrors(response.data.errors, $(this));
                    enableFormBack(this);
                    spinner.destroy();
                    toastAlert('Wystąpił błąd podczas zapisu formularza.', {type: 'danger'})
                }

                return;
            }

            toastAlert('Pomyślnie zapisano zmiany', {type: 'success'})
            enableFormBack(form);
        } catch (err) {
            toastAlert('Wystąpił błąd podczas zapisu formularza.', {type: 'danger'})
        } finally {
            spinner.destroy();
        }
    }

    form.on('file_submit', () => {
        submitForm(form);
    })

    form.on('submit', function (e) {
        e.preventDefault();

        // when no photos, just submit the form
        // otherwise, we must wait for images to upload - this will be
        // handled by the file_submit event above
        if(!isWithPhotos) {
            submitForm(form)
        }

        // const add = (item, name) => {
        //     form.append(`<input type="hidden" name="item[${item.id}][${name}]" value="${item[name]}" />`)
        // }
        //
        // for (let item of items) {
        //     add(item, 'id')
        //     add(item, 'animal_type_id')
        //     add(item, 'animal_id')
        //     add(item, 'quantity')
        //     add(item, 'comments')
        //     add(item, 'exists')
        //     add(item, 'is_edited')
        //
        //     if (inventoryType === 4) {
        //         add(item, 'is_inspected')
        //         // add(item, 'settlement_type')
        //     }
        //
        //     for (let detail of item.details) {
        //         // if(inventoryType === 4 && parseInt(item.settlement_type) === 1) {
        //         //     continue;
        //         // }
        //
        //         form.append(`<input type="hidden" name="item[${item.id}][details][${detail.dictionary_id}][dictionary_id]" value="${detail.dictionary_id}" />`)
        //         form.append(`<input type="hidden" name="item[${item.id}][details][${detail.dictionary_id}][value]" value="${detail.value}" />`)
        //     }
        // }

        // this.submit();
    })

    // $('[name="settlement_type"]').change(function() {
    //     if(parseInt($(this).val()) === 1) {
    //         dictionaryInputsContainer.hide();
    //         return;
    //     }
    //
    //     dictionaryInputsContainer.show();
    // })

    modal.on('hide.bs.modal', function () {
        editingId = null;
        updateModal();
    })

    // modal.on('show.bs.modal', function () {
    //     if(inventoryType === 4) {
    //         $('[name="settlement_type"]').change();
    //     }
    // })

    const updateModal = () => {
      clearErrors(modal)

        if (editingId !== null) {
            modal.find('.modal-title').text('Edycja zwierzyny');
            modal.find('#btnAddData').text('Zapisz');
        } else {
            modal.find('.modal-title').text('Dodawanie zwierzyny');
            modal.find('#btnAddData').text('Dodaj');
        }
    }

    const redrawTable = () => {
        if (inventoryType === 4) {
            if (items.length > 0) {
                addItemButton.hide();
            } else {
                addItemButton.show();
            }
        }

        const api = itemsTable.DataTable().api();

        api.clear();

        for (let item of items) {
            const type = getTypeFromTree(item.animal_type_id);
            const subtype = getSubtypeFromTree(item.animal_type_id, item.animal_id);

            let details = '';
            if (inventoryType === 4) {
                details += 'Zlustrowane: ' + (parseInt(item.is_inspected) === 1 ? 'Tak' : 'Nie');
                // details += ', ';

                // let settlement = '';
                // if (parseInt(item.settlement_type) === 1) {
                //     settlement = 'Niezasiedlone';
                // } else if (parseInt(item.settlement_type) === 2) {
                //     settlement = 'Zasiedlone';
                // } else {
                //     settlement = 'Zlikwidowane';
                // }
                // details += 'Zasiedlenie: ' + settlement;
            }

            for (let detail of item.details) {
                let dictionary = subtype.dictionaries.find(d => parseInt(d.id) === parseInt(detail.dictionary_id));
                if (!dictionary) {
                    continue;
                }

                let value = null;

                if(parseInt(dictionary.type) === 1) {
                    let entry = dictionary.entries.find(e => parseInt(e.id) === parseInt(detail.value));
                    if (entry) {
                        value = entry.name;
                    }
                } else if(parseInt(dictionary.type) === 4 && detail.value) {
                    value = moment.unix(detail.value).format('DD/MM/YYYY');
                } else {
                    value = detail.value;
                }

                if(value != null) {
                    if (details.length > 0) {
                        details += '; ';
                    }

                    details += dictionary.name + ': ' + value;
                }
            }

            let withQuantity = true;
            if (inventoryType === 4) {
                withQuantity = false;
            }

            let row = $(`
                <tr>
                    <td>${type.name}</td>
                    <td>${type.animals.length > 1 ? subtype.name : ''}</td>
                    ${withQuantity ? `<td>${item.quantity}</td>` : ''}
                    <td>${details}</td>
                    <td>${item.comments.length ? "<span data-bs-toggle='tooltip' title='"+item.comments+"'><i class='fas fa-info-circle text-info'></i></span>" : "brak"}</td>
                    <td>
                        <div class="btn-group" role="group">
                            <button data-id="${item.id}" type="button" class="btn btn-primary btn-sm btnEditItem">
                                Edytuj
                            </button>
                            <button data-id="${item.id}" type="button" class="btn btn-danger btn-sm btnDeleteItem">
                                Usuń
                            </button>
                        </div>
                    </td>
                </tr>
            `)

            api.rows.add(row);
        }

        api.draw();
    }

    body.on('click', '.btnDeleteItem', async function () {
        let id = $(this).data('id');

        if (await confirmModal('Czy jesteś pewny/a, że chcesz usunąć tą pozycję?')) {
            items = items.filter(p => (p.id).toString() !== (id).toString());
            redrawTable();
        }
    });

    body.on('click', '.btnEditItem', function () {
        editingId = $(this).data('id');
        let item = items.find(p => p.id.toString() === editingId.toString());

        if (!item) {
            return;
        }

        typeInput.val(item.animal_type_id).change();
        subtypeInput.val(item.animal_id).change();

        if (item.quantity && quantityInput.length > 0) {
            quantityInput.val(item.quantity);
        }

        commentsInput.val(item.comments);

        if (inventoryType === 4) {
            $('[name="is_inspected"]').prop('checked', parseInt(item.is_inspected) === 1);
            // $('[name="settlement_type"]').val(item.settlement_type);
        }

        for (let detail of item.details) {
            let animal = getSubtypeFromTree(typeInput.val(), subtypeInput.val());
            let dictionary = animal.dictionaries.find(d => parseInt(d.id) === parseInt(detail.dictionary_id));

            if(dictionary && parseInt(dictionary.type) === 4 && detail.value) {
                $(`[name="dictionary-${detail.dictionary_id}"]`).val(moment.unix(detail.value).format('DD/MM/YYYY'));
            } else {
                $(`[name="dictionary-${detail.dictionary_id}"]`).val(detail.value);
            }
        }

        hasBeenEdited = false;

        updateModal();
        openModal('#addItemModal')
    })

    body.on('change', '#addItemModal :input', function() {
        hasBeenEdited = true;
    })

    let geometriesConverted = [];

    const findAndChooseClosestGeometry = () => {
        const latitude = parseFloat(latitudeInput.val());
        const longitude = parseFloat(longitudeInput.val());

        if(!latitude || !longitude) {
            return;
        }

        const point = turf.point([longitude, latitude]);

        let nearestDistance = null;
        let nearestGeometry = null;

        for(let geometry of geometriesConverted) {
            const distance = turf.pointToLineDistance(point, geometry.geojson);
            if(nearestDistance === null || distance < nearestDistance) {
                nearestDistance = distance;
                nearestGeometry = geometry.id;
            }
        }

        if(nearestGeometry) {
            window._inventory_location_geometry_id = parseInt(nearestGeometry);
            $('[name="inventory_location_geometry_id"]').val(nearestGeometry).change();
        }
    }

    // set geometries
    if(inventoryType === 5) {
        inventoryLocationInput.change(function() {
            const id = parseInt($(this).val())
            const location = locations.find(location => parseInt(location.id) === id);

            geometriesConverted = [];
            for(let geometry of location.geometries) {
                geometriesConverted.push({
                    id: geometry.id,
                    geojson: coordinatesToGeoJSON(geometry.coordinates, 'LineString')
                });
            }

            const select = $('[name="inventory_location_geometry_id"]');
            if(select.length) {
                select.find('option').remove();

                let transectIndex = 1;
                let areaIndex = 1;

                for(let geometry of location.geometries) {
                    let name = '';
                    if(parseInt(geometry.type) === 1) {
                        name = 'Transekt #'+transectIndex;
                        transectIndex++;
                    } else {
                        name = 'Teren #'+areaIndex;
                        areaIndex++;
                    }

                    let areaTypeName = 'leśny';
                    if(parseInt(geometry.area_type) === 2) {
                        areaTypeName = 'polny';
                    }

                    let selected = false;
                    if(parseInt(geometry.id) === parseInt(window._inventory_location_geometry_id)) {
                        selected = true;
                    }

                    select.append(`<option ${selected ? 'selected' : ''} value="${geometry.id}">${name} (rodzaj obszaru: ${areaTypeName})</option>`)
                }
            }
        }).trigger('change')

        setTimeout(() => {
            $('[name="inventory_location_id"]').change(function() {
                findAndChooseClosestGeometry()
            })

            $('[name="latitude"], [name="longitude"]').change(function() {
                findAndChooseClosestGeometry()
            })
        }, 1000)
    }

    $('#btnAddData').click(function () {
        let item = buildItemFromForm($('#addItemModal'));
        clearErrors()

        // validation
        if(item.quantity.length === 0 || parseInt(item.quantity) <= 0 || isNaN(item.quantity)) {
            handleValidationErrors({quantity: "Liczba sztuk jest wymagana"})
            return;
        }

        let animal = getSubtypeFromTree(typeInput.val(), subtypeInput.val());
        if(animal) {
          let hasDictionaryErrors = false;

          for (let dictionary of animal.dictionaries) {
            if(dictionary.is_required === "1") {
              const detail = item.details?.find(d => d.dictionary_id === dictionary.id);

              if(!detail || detail.value.length === 0) {
                handleValidationErrors({[`dictionary-${dictionary.id}`]: `Pole "${dictionary.name}" jest wymagane`})
                hasDictionaryErrors = true;
              }
            }
          }

          if(hasDictionaryErrors) {
            // return
          }
        }

        if (editingId !== null) {
            let itemIndex = items.findIndex(p => (p.id).toString() === (editingId).toString());
            if (itemIndex !== -1) {
                let is_edited = items[itemIndex].is_edited;
                if(is_edited === false && hasBeenEdited) {
                    is_edited = true;
                }

                items[itemIndex] = {
                    ...items[itemIndex],
                    ...item,
                    is_edited,
                };
            }
        } else {
            items = [
                ...items,
                {
                    id: nanoid(),
                    ...item,
                    exists: false
                }
            ]
        }

        commentsInput.val('');
        quantityInput?.val(1);

        redrawTable();
        closeModal('#addItemModal')
    })

    /// Inventory locations
    // inventoryLocationInput.change(function () {
    //     let option = $(this).find(`option[value="${$(this).val()}"]`);
    //
    //     if (option.length > 0) {
    //         let html = '';
    //         if ($(this).data('description')) {
    //             html = option.data('description');
    //         }
    //
    //         if (html.length > 0) {
    //             html += '<br />';
    //         }
    //
    //         html += `<strong>Data: </strong> ${option.data('date')}`;
    //
    //         $('.locationData').html(html)
    //     }
    // }).change();

    /// Map
    if (mapContainer.length > 0) {
        let epMap = new EpMap({
            target: 'mapContainer',
            hideLabelsIfNecessary: true,
            ruler: true,
            fitSectorsAndBoundariesAfterInit: false
        });
        let map = epMap.getOlMap();

        epMap.addSectorsLayer();
        epMap.addBoundariesLayer()

        let locationsLayer = new EpLayer(epMap.map);
        locationsLayer.setStyle(inventoryLocationStyle, farInventoryLocationStyle);
        locationsLayer.name = 'locations';
        locationsLayer.title = 'Obszary';
        epMap.addCustomLayer(locationsLayer);

        epMap.changeStyleUnderZoom(locationsLayer)

        let observationsLayer = new EpInventoryObservations();
        let observationsSource = observationsLayer.getSource();
        epMap.addCustomLayer(observationsLayer);

        let locationThermalImagingAreasLayer = null;
        let locationThermalImagingTransectsLayer = null;
        let locationRoutesLayer = null;

        if(parseInt(window._inventory_type) === 5) {
            locationThermalImagingAreasLayer = new EpInventoryLocationAreas(epMap.map)
            epMap.addCustomLayer(locationThermalImagingAreasLayer);

            locationThermalImagingTransectsLayer = new EpInventoryLocationTransects(epMap.map)
            epMap.addCustomLayer(locationThermalImagingTransectsLayer);

            locationRoutesLayer = new EpInventoryLocationRoutes(epMap.map)
            epMap.addCustomLayer(locationRoutesLayer);
        }

        if (typeof window._sectors != 'undefined') {
            epMap.sectors.addSectorsFromObject(JSON.parse(window._sectors));
        }


        inventoryLocationInput.change(function () {
            let id = parseInt($(this).val());

            if (locations.length > 0) {
                locationsLayer.getSource().clear();

                let location = locations.find(l => parseInt(l.id) === id);
                if(location.district) {
                    epMap.boundaries.getSource().clear();

                    if(location.district.coordinates) {
                        epMap.boundaries.addFeature(location.district.coordinates);
                    }
                }

                if (location) {
                    locationsLayer.addFeature(location.coordinates, {
                        fields: {
                            name: location.name
                        }
                    });

                    if(parseInt(window._inventory_type) === 5) {
                        locationThermalImagingAreasLayer.getSource().clear();
                        locationThermalImagingTransectsLayer.getSource().clear();
                        locationRoutesLayer.getSource().clear();

                        for(const geometry of location.geometries) {
                            if(parseInt(geometry.type) === 1) {
                                const line = locationThermalImagingTransectsLayer.addFeature(geometry.coordinates, {type: 'LineString'})
                                line.setStyle(inventoryLocationStyle)

                                locationThermalImagingTransectsLayer.createSimplifiedTransectsCollection(geometry.features)
                            } else {
                                locationThermalImagingAreasLayer.addFeature(geometry.coordinates)
                            }
                        }

                        for(const route of location.routes) {
                            locationRoutesLayer.addFeature(route.coordinates, {type: 'LineString'})
                        }

                        epMap.boundaries.fitInView()
                    } else {
                        locationsLayer.fitInView();
                    }

                    if(inventoryType === 4) {
                        for (let feature of observationsLayer.getSource().getFeatures()) {
                            if (feature.get('data')) {
                                observationsLayer.getSource().removeFeature(feature);
                            }
                        }

                        let availableObservations = observations.filter(o => parseInt(o.location.id) === id)
                        for (let observation of availableObservations) {
                            observationsLayer.addObservation(observation)
                        }

                        epMap.setupTooltips('tooltip', ['observation'])
                    }

                }
            }
        }).change();

        epMap.hideLabelsIfNecessary(epMap.getEpLayerByName('sectors'));

        map.on('click', async function (evt) {
            let features = epMap.getOlMap().getFeaturesAtPixel(evt.pixel, {
                layerFilter: (layer) => layer === observationsLayer.getLayer()
            });
            if (features.length > 0) {
                let feature = features[0];

                if (feature.get('data')) {
                    if (await confirmModal('Czy chcesz zaktualizować dane dotyczące wybranej obserwacji?')) {
                        let query = new URLSearchParams(window.location.search);
                        query.set('observation_id', feature.get('data').id);
                        query.set('ref', 'add');

                        releaseUnsubmittedForm(form.attr('id'))

                        window.location.search = query.toString();
                    }

                    return;
                }
            }

            let latLng = transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326');
            longitudeInput.val(latLng[0].toPrecision(8));
            latitudeInput.val(latLng[1].toPrecision(8));

            latitudeInput.change();
        });

        $('.btnGetLocalization').click(function () {

            let geo = navigator.geolocation;

            try {
                if (geo) {
                    geo.getCurrentPosition(function (location) {
                        latitudeInput.val(location.coords.latitude.toPrecision(8));
                        longitudeInput.val(location.coords.longitude.toPrecision(8));

                        latitudeInput.change();

                        toastAlert(`Pozycja została ustalona z dokładnością do ${Math.round(location.coords.accuracy)} m. <strong><u>Sprawdź poprawność danych na mapie.</u></strong>`, {type: "info"});
                    }, () => {
                        toastAlert('Podczas pobierania lokalizacji wystąpił błąd. Spróbuj ponownie później.', {type: 'danger'})
                    });
                } else {
                    toastAlert('Podczas pobierania lokalizacji wystąpił błąd. Spróbuj ponownie później.', {type: 'danger'})
                }
            } catch (err) {
                toastAlert('Podczas pobierania lokalizacji wystąpił błąd. Spróbuj ponownie później.', {type: 'danger'})
            }
        })

        $('[name="latitude"], [name="longitude"]').change(function () {
            if (longitudeInput.val().length === 0 && latitudeInput.val().length === 0) {
                return;
            }

            let feature = observationsSource.getFeatures().find(feature => !feature.get('data'));
            observationsSource.removeFeature(feature);

            try {
                observationsLayer.addFeature([parseFloat(longitudeInput.val()), parseFloat(latitudeInput.val())]);
            } catch (e) {
                toastAlert('Wprowadzono błędną lokalizację.', {type: "danger"});
            }
        }).change();
    }

    // change forestry
    $('[name="forest_address_forestry_id"]').change(function() {
        const id = parseInt($(this).val());
        const subareaInput = $('[name="forest_address_subarea_id"]');

        const forestry = forestries.find(f => parseInt(f.id) === id);
        if(forestry) {
            subareaInput.empty();

            for(const subarea of forestry.subareas) {
                const option = $(`<option value="${subarea.id}">${subarea.display_name}</option>`)

                if(parseInt(window._default_subarea) === parseInt(subarea.id)) {
                    option.attr('selected', true);
                }

                subareaInput.append(option);
            }
        }
    }).change();

    /// Init data
    if (typeof window._baseItems != 'undefined') {
        let baseItems = JSON.parse(window._baseItems);

        items = baseItems.map((baseItem, index) => ({
            id: baseItem.id ?? index + 1,
            ...baseItem,
            details: Object.values(baseItem.details ?? {}),
            exists: true,
            is_edited: baseItem.is_edited ?? false,
        }))

        if (items.length > 0) {
            redrawTable()
        }
    }

}